export const environment = {
  production: true,
  api_host: 'https://api.spinsamurai.com/api',
  ss_api_host: 'https://spinsamurai.com/api',
  ss_host: 'https://spinsamurai.com',
  cms_host: 'https://api.spinsamurai.com',
  assets_host: 'https://media.spinsamurai.com',
  error_host: 'https://error.spinsamurai.com',
  mlh_host: 'https://mlh.spinsamurai.com',
  mirror_host_cz: 'https://www.spinsamurai2.com',
  mirror_host_au: 'https://www.spinsamurai11.com',
  redirector_host: 'https://api.dstat.site/api',
  app_host: 'https://www.spinsamurai.com',
  wr_websocket: 'https://ue.gmngeng.com',
  zendesk_host: 'https://zendesk.dstat.site',
  hotjar_id: 1870206,
  hotjar_version: 6
};

export enum TransactionLimit {
  MAX_COUNT = 30,
  STORAGE_KEY = 'transactionLimit',
  DISABLED_TIME = 10
}
export enum BannerType {
  TOP_SLIDER = 5,
  BOTTOM_SLIDER = 6,
  BOTTOM_STICKY = 7,
  REVIEW = 9,
  SIGN_UP = 11,
  POPUP_BLOCKER = 19,
  TOP_WINNERS = 10,
  LOW_BALANCE = 15,
  ABOUT_US_FOOTER = 23,
  MOBILE_APP = 27,
  MOBILE_APP_REDESIGN = 30
}

export enum SocialAuthLink {
  FACEBOOK = 'https://spinsamurai.com/users/auth/facebook',
  GOOGLE = 'https://spinsamurai.com/users/auth/google_oauth2',
  TWITTER = 'https://spinsamurai.com/users/auth/twitter'
}

export enum BlogType {
  TEXT = '1',
  VIDEO = '2'
}

export enum StaticContentType {
  TOP_FEATURES = 13,
  TOP_FEATURES_JP = 18,
  PARTNERS = 14,
  LOYALTY_BONUSES = 16,
  TOP_FEATURES_ABOUT = 21,
  BUY_CRYPTO = 23,
  VIP_LEVELS = 28,
}

export const MOBILE_APP_ID = '1501ba0a504bf9b01536746d62105b4ad';
export const MOBILE_APP_DECODE_MAP = 'towquysnkdejim_fbra.g/pvhlx:zc-1234567890'
